import React from 'react';
import { BrListWrapper } from '@app/ui/pages/landing-page/br-list/br-list.styles';
import { BrItem } from '@app/ui/pages/landing-page/br-list/br-item/br-item.component';
// @ts-ignore
import imageSpeed from '@app/assets/br-speed.svg';
// @ts-ignore
import imageRozetka from '@app/assets/br-rozetka.svg';
// @ts-ignore
import imageClock from '@app/assets/br-clock.svg';
// @ts-ignore
import imageWifi from '@app/assets/br-wifi.svg';

export const BrList = () => {
  return (
    <BrListWrapper>
      <BrItem caption='Быстрое бесплатное подключение' image={imageRozetka} />
      <BrItem caption='Стабильная скорость' image={imageSpeed} />
      <BrItem caption='Бесплатный месяц интернета' image={imageClock} />
      <BrItem caption='Гибкие тарифные планы' image={imageWifi} />
    </BrListWrapper>
  );
};
